export default "__VITE_ASSET__a394fec9__"